<div class="container">
  <img src="imgs/thinking.png" class="logo-icon">
  <span class="loader"></span>
</div>

